import { formatDate } from 'src/utils/dateUtils'
import { getLocalizedName } from 'src/utils/localizedName'
import { AppLanguage } from 'ufinet-web-functions'

import { FTTHIncidentDTO } from '../application/dto/FTTHIncidentDto'
import { FTTHIncidentFindResponse } from '../application/dto/FTTHIncidentFindResponse'

export const responseToDto = (response: FTTHIncidentFindResponse, lang: AppLanguage): FTTHIncidentDTO => {
	return {
		incidentDetail: incidentDetail(response, lang),
		incidentDetailClosed: incidentDetailClosed(response, lang),
	}
}

const incidentDetail = (response: FTTHIncidentFindResponse, lang: AppLanguage) => {
	return {
		incidentId: response.incidentId,
		externalId: response.externalId,
		ticketName: response.ticketName,
		ticketId: response.ticketId,
		customerName: response.customerName,
		creationDate: formatDate(response.createdDate, '-', true, false, true),
		ticketStatus: getLocalizedName(response.processStatus, lang),
		ticketStatusId: response.processStatus.processStatusId,
		lastStatus: formatDate(response.modifiedDate, '-', true, false, true),
		clientId: response.customerId,
		reportType: getLocalizedName(response.reportType, lang),
		reportClassification : getLocalizedName(response.reportClassification, lang),
		reportClassificationId: response.reportClassification ? response.reportClassification.reportClassificationId : null,
		qtCategory : getLocalizedName(response.qtCategory, lang),
		qtCategoryId: response.qtCategory ? response.qtCategory.qtCategoryId : null,
		incidentDescription: response.description,
		reportOrigin: getLocalizedName(response.reportOrigin, lang),
		customerTicketNumber: response.internalCustomerTicketNumber,
		reportUser: response.reportContactEmail,
		notificationGroup: response.notificationGroup.name,
		visitDate: formatDate(response.visitingHours, '-', true, false, true),
		visitContactName: response.visitContactName,
		visitContactPhone: response.visitContactPhone,
		visitRequirements: response.visitRequirements,
		administrativeCode: response.administrativeCode,
		serviceType: getLocalizedName(response.serviceType, lang),
		bandwidthCapacity: response.bandwidthCapacity,
		originCountryName: response.originCountryName,
		destinationCountryName: response.destinationCountryName,
		incidentTitle: response.incidentTitle,
		transmissionMedium: getLocalizedName(response.transmissionMedium, lang),
		vlanClient: response.vlanClient,
		publicIp: response.publicIp,
	}
}

const incidentDetailClosed = (response: FTTHIncidentFindResponse, lang: AppLanguage) => {
	return {
		resetDate: formatDate(response.serviceRestorationDate, '/', true),
		closeDate: formatDate(response.statusCloseDate, '/', true, false, true),
		solutionType: getLocalizedName(response.solutionType, lang),
		primaryCause: getLocalizedName(response.primaryCause, lang),
		secondaryCause: getLocalizedName(response.secondaryCause, lang),
		confirmedWith: response.confirmedWith,
		latitudeLongitudeFailure:
			response.latitudeFailure || response.longitudeFailure
				? `${response.latitudeFailure}, ${response.longitudeFailure}`
				: '',
		rfoSummary: response.summaryRfo,
		rfoSentDate: formatDate(response.rfoSentDate, '/', true),
		additionalComments: response.additionalComments,
		attributableTo: getLocalizedName(response.attributableTo, lang),
		discountTime: response.totalDiscountTime,
		discountReason: response.descriptionDiscountTime,
	}
}
